import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../hooks/usePortalRoutes";
import { RouteFeature } from "../../../../routes/feature";
import { RouteLayout } from "../../../../routes/layout";
import ReportWidgetCard from "../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../ReportContext";

export const ReportLateCancellationsWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const history = useHistory();
  const { createClubLink } = usePortalRoutes();
  const data = useContext(ReportContext);

  return (
    <ReportWidgetCard
      title="Late Cancellations"
      value={data.events?.lateCancellations?.total.toString() || "0"}
      isLoading={data.isLoading}
      explanation="How many members cancelled late during the selected period."
      variation={data.events?.lateCancellations?.variation}
      onClick={() =>
        history.push({
          pathname: createClubLink(
            RouteLayout.Staff,
            RouteFeature.LateCancellations,
          ),
          search: QueryString.stringify({
            startDate: data.startDate,
            endDate: data.endDate,
            backRoute: parentRoute,
          }),
        })
      }
    />
  );
};
